(function initFulfillmentGate(global) {
  if (!global || global.EtFulfillmentGate) return;

  function normalizeString(value) {
    return value == null ? '' : String(value).trim();
  }

  function normalizeLocationId(value) {
    const raw = normalizeString(value);
    if (!raw) return '';
    if (global.EtInventoryDomain && typeof global.EtInventoryDomain.normalizeLocationId === 'function') {
      return global.EtInventoryDomain.normalizeLocationId(raw);
    }
    if (raw.indexOf('gid://shopify/Location/') !== -1) {
      const parts = raw.split('/');
      return parts[parts.length - 1] || raw;
    }
    return raw;
  }

  function normalizeTime(value) {
    const raw = normalizeString(value).toUpperCase();
    if (!raw) return '';

    const already24h = raw.match(/^(\d{1,2}):(\d{2})$/);
    if (already24h) {
      const hours = String(parseInt(already24h[1], 10)).padStart(2, '0');
      return `${hours}:${already24h[2]}`;
    }

    const match = raw.match(/(\d{1,2})\s*:\s*(\d{2})\s*(AM|PM)/);
    if (!match) return raw.replace(/\s+/g, ' ');
    let hours = parseInt(match[1], 10);
    const minutes = match[2];
    const period = match[3];
    if (period === 'PM' && hours !== 12) hours += 12;
    if (period === 'AM' && hours === 12) hours = 0;
    return `${String(hours).padStart(2, '0')}:${minutes}`;
  }

  function getKey(constants, constantName, fallback) {
    return (constants && constants[constantName]) || fallback;
  }

  function getSelectionFromStorage(constants) {
    const cfg = constants || global.FulfillmentConstants || {};
    const zipKey = getKey(cfg, 'ZIP_CODE', 'selected_zip_code');
    const locationKey = getKey(cfg, 'LOCATION_ID', 'selected_location_id');
    const dateKey = getKey(cfg, 'DATE', 'selected_fulfillment_date');
    const typeKey = getKey(cfg, 'DELIVERY_TYPE', 'selected_delivery_type');
    const timeKey = getKey(cfg, 'TIME', 'selected_fulfillment_time');

    const deliveryType = normalizeString(global.localStorage.getItem(typeKey)).toLowerCase();
    return {
      zipCode: normalizeString(global.localStorage.getItem(zipKey)),
      locationId: normalizeLocationId(global.localStorage.getItem(locationKey)),
      fulfillmentDate: normalizeString(global.localStorage.getItem(dateKey)),
      deliveryType: deliveryType,
      fulfillmentTime: normalizeTime(global.localStorage.getItem(timeKey))
    };
  }

  function selectionHasRequiredFields(selection) {
    const hasBase =
      Boolean(selection.zipCode) &&
      Boolean(selection.locationId) &&
      Boolean(selection.fulfillmentDate) &&
      Boolean(selection.deliveryType);
    if (!hasBase) return false;
    if (selection.deliveryType !== 'delivery') return true;
    return Boolean(selection.fulfillmentTime);
  }

  function cartMatchesSelection(cart, selection) {
    const attrs = (cart && cart.attributes) || {};
    const cartSelection = {
      zipCode: normalizeString(attrs._zipCode),
      locationId: normalizeLocationId(attrs.LocationID),
      fulfillmentDate: normalizeString(attrs._selectedFulfillmentDate),
      deliveryType: normalizeString(attrs['Fulfillment Type']).toLowerCase(),
      fulfillmentTime: normalizeTime(attrs._selectedFulfillmentTime)
    };

    const baseMatches =
      cartSelection.zipCode === selection.zipCode &&
      cartSelection.locationId === selection.locationId &&
      cartSelection.fulfillmentDate === selection.fulfillmentDate &&
      cartSelection.deliveryType === selection.deliveryType;

    if (!baseMatches) return false;
    if (selection.deliveryType !== 'delivery') return true;
    return cartSelection.fulfillmentTime === selection.fulfillmentTime;
  }

  async function fetchCart() {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) {
      throw new Error(`/cart.js request failed with status ${response.status}`);
    }
    return response.json();
  }

  async function syncAndVerifyCartSelection(selection) {
    if (typeof global.syncAllAttributesToCart !== 'function') {
      return { ok: false, reason: 'sync_unavailable' };
    }
    try {
      await global.syncAllAttributesToCart({ force: true });
    } catch (error) {
      return { ok: false, reason: 'sync_failed', error: error };
    }

    try {
      const recheckCart = await fetchCart();
      const matches = cartMatchesSelection(recheckCart, selection);
      return {
        ok: matches,
        reason: matches ? 'synced' : 'cart_mismatch_after_sync',
        cart: recheckCart
      };
    } catch (error) {
      return { ok: false, reason: 'cart_fetch_failed_after_sync', error: error };
    }
  }

  async function validateForAction() {
    if (typeof global.ensureFreshFulfillmentSelection === 'function') {
      try {
        await global.ensureFreshFulfillmentSelection({ syncCart: true, rerenderSummary: true });
      } catch (_error) {}
    }

    const selection = getSelectionFromStorage();
    if (!selectionHasRequiredFields(selection)) {
      return { ok: false, reason: 'missing_selection', selection: selection };
    }

    let cart;
    try {
      cart = await fetchCart();
    } catch (error) {
      return { ok: false, reason: 'cart_fetch_failed', selection: selection, error: error };
    }

    if (cartMatchesSelection(cart, selection)) {
      return { ok: true, reason: 'cart_matches_selection', selection: selection, cart: cart };
    }

    const syncResult = await syncAndVerifyCartSelection(selection);
    if (!syncResult.ok) {
      return {
        ok: false,
        reason: syncResult.reason || 'cart_mismatch',
        selection: selection,
        cart: syncResult.cart || cart,
        error: syncResult.error
      };
    }

    return { ok: true, reason: 'cart_synced_and_verified', selection: selection, cart: syncResult.cart || cart };
  }

  global.EtFulfillmentGate = {
    normalizeString: normalizeString,
    normalizeLocationId: normalizeLocationId,
    normalizeTime: normalizeTime,
    getSelectionFromStorage: getSelectionFromStorage,
    selectionHasRequiredFields: selectionHasRequiredFields,
    cartMatchesSelection: cartMatchesSelection,
    syncAndVerifyCartSelection: syncAndVerifyCartSelection,
    validateForAction: validateForAction
  };
})(window);
